module.exports = __webpack_public_path__ + "img/bni.32c5252d.png";